import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "./Style.css";
import { Button, Radio, Input, Table, Menu, Dropdown, Select, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { SearchOutlined, EditOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import { partnerDataSuccess } from "../../redux/PricingPartnerDetails/PricingPartnerDetailsAction";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { PartnerPricingdata } from "./helper/PricingdashboardData";
import { getCategoryList } from "../../redux/PricingSetupCategory/pricingSetupCategoryAction";
import { partnerDetailForApproved, partnerDetailForPendingApproval, partnerDetailForQuery, partnerDetailForRejected, partnerDetailForResolved } from "../../redux/PartnerDetailbyStatus/action";
import Logout from "../../containers/Pages/Login/Logout";
import useSession from "../CustomLogout/useSession";


const PricingManagement = (props) => {
  const [partnerdata, setPartnerData] = useState([]);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [dataSource2, setDataSource2] = useState([]);
  const [fullDataSource, setFullDataSource] = useState([]); // <-- NEW STATE
  const [searchText, setSearchText] = useState("");
  const [catogryStatus, setCatogryStatus] = useState("Approved");
  const [visible, setVisible] = useState(false);
  const [makerAction, setMakerAction] = useState(props.makerAction);
  const navigate = useNavigate();
  const handleSessionExpired = useSession();
  const { partnersdata1, accessToken} = props;


  // Debounced search function
  const debouncedSearch = debounce((value) => {
    const searchValue = String(value || "")
      .trim()
      .toLowerCase();
    if (searchValue) {
      // filter from the full data source
      const filteredData = fullDataSource.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchValue)
        )
      );
      setDataSource2(filteredData);
    } else {
      // Show all data when search is cleared
      setDataSource2(fullDataSource);
    }
  }, 300);

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };

  const clearSearch = () => {
    setSearchTextTable("");
    setDataSource2(fullDataSource);
  };

  const handelviewPringdataforPartner2 = (data) => {
    if(makerAction){
      navigate(`/PayoutMakerDashBoard/PartnerPricingView`, {
        state: { SelectedPartnerCode: data },
        replace: true,
      });
    }else{
      navigate(`/PayoutCheckerDashBoard/PartnerPricingView`, {
        state: { SelectedPartnerCode: data },
        replace: true,
      });
    }
  };

  // Generate data source with serial numbers
  const dataSource = (PData) => {
    let mappedData =
      PData == null
        ? []
        : PData.map((item, index) => ({
            ...item,
            partnerDisplayCode: item.partnerDisplayCode? item.partnerDisplayCode : "--",
            RecoveryMonth:1,
            operations: (<Button
              style={{  margin: "3px", background: "#1b8593", color: "#fff" }}
              onClick={() => handelviewPringdataforPartner2(item.partnerFirmId)}
            >
              <EyeOutlined /> View Pricing
            </Button>),
          }));
    setFullDataSource(mappedData); // <-- SET FULL DATA SOURCE
    setDataSource2(mappedData);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = props.partnerData({
          accessToken: accessToken,
        });
        const ted = props.categorySetup({
          accessToken: accessToken,
        });

        const newPartnerdata = await result;

        if (newPartnerdata) {
          const errorCode = newPartnerdata?.response?.data?.error?.errorCode || newPartnerdata.errorCode;
          const errorMessage = newPartnerdata?.response?.data?.error?.message || newPartnerdata.message;

          if (errorCode === "403" && (newPartnerdata?.data?.error?.logoutStatus || newPartnerdata?.response?.data?.error?.logoutStatus)) {
            handleSessionExpired();
            return; // Stop further execution
          }
          handleRadioChange(catogryStatus, PartnerPricingdata);
          setPartnerData(newPartnerdata);
        } else {
          console.error("newPartnerdata is undefined");
        }
      } catch (e) {
        // Check for 403 in error object (AxiosError)
        if (e?.status === 403 || e?.response?.status === 403) {
          handleSessionExpired();
          return;
        }
        console.log(e);
      }
    };

    fetchData();
  }, [props.partnerData]);

  const options = [
    { label: "Approved", value: "Approved" },
    { label: "Pending For Approval", value: "PendingForApproval" },
    { label: "Query", value: "Query" },
    { label: "Resolved", value: "Resolved" },
    { label: "Rejected", value: "Rejected" },
  ];

  const columns = [
    {
      title: "Partner Name",
      dataIndex: "partnerFirmName",
      key: "partnerFirmName",
      align: "center",
      sorter: (a, b) => {
        const isANumeric = /^\d/.test(a.partnerFirmName);
        const isBNumeric = /^\d/.test(b.partnerFirmName);

        if (isANumeric && !isBNumeric) return 1; // a is numeric, b is not: a after b
        if (!isANumeric && isBNumeric) return -1; // b is numeric, a is not: a before b
        return a.partnerFirmName.localeCompare(b.partnerFirmName);
      },
      ellipsis: true,
    },
    { title: "Onboarding Date", dataIndex: "onBoardingDate", key: "onBoardingDate", align: "center" },
    {
      title: "Action",
      dataIndex: "operations",
      key: "operations",
      align: "center",
    },
  ];

  const filteredPartners = Array.isArray(partnerdata) && partnerdata.length > 0
  ? partnerdata.filter((partner) =>
      partner.partnerFirmName.toLowerCase().includes(searchText.toLowerCase())
    )
  : [];

  const handleMenuClick = (e) => {
    if (!e.key || e.key === "search") {
      message.error("Please select and click on valid partner.");
      return;
    }
    
    setVisible(false);
    navigate(`/PayoutMakerDashBoard/AddPartnerPricing`, {
      state: { SelectedPartnerCode: e.key },
    });
  };

  const handleRadioChange = async (value, data = null) => {
    const PratnerFromState = PartnerPricingdata;

    switch (value) {
      case "Approved":
        {
          const res = props.partnerdataforApproved({
            accessToken: accessToken, });
          const approvedData = await res;
          dataSource(
            approvedData?.slice()?.sort((a, b) => {
              const isANumeric = /^\d/.test(a.partnerFirmName);
              const isBNumeric = /^\d/.test(b.partnerFirmName);

              if (isANumeric && !isBNumeric) return 1;
              if (!isANumeric && isBNumeric) return -1;
              return a.partnerFirmName.localeCompare(b.partnerFirmName);
            })
          );
          setCatogryStatus("Approved");
        }
        break;

      case "PendingForApproval":
        {
          const res1 = props.partnerdataforPendingApproval({
            accessToken: accessToken, });
          const PendingForApprovalData = await res1;
          dataSource(
            PendingForApprovalData?.slice()?.sort((a, b) => {
              const isANumeric = /^\d/.test(a.partnerFirmName);
              const isBNumeric = /^\d/.test(b.partnerFirmName);

              if (isANumeric && !isBNumeric) return 1;
              if (!isANumeric && isBNumeric) return -1;
              return a.partnerFirmName.localeCompare(b.partnerFirmName);
            })
          );
          setCatogryStatus("PendingForApproval");
        }
        break;

      case "Query":
        {
          const res2 = props.partnerdataforQuery({
            accessToken: accessToken, });
          const QueryData = await res2;
          dataSource(
            QueryData?.slice()?.sort((a, b) => {
              const isANumeric = /^\d/.test(a.partnerFirmName);
              const isBNumeric = /^\d/.test(b.partnerFirmName);

              if (isANumeric && !isBNumeric) return 1;
              if (!isANumeric && isBNumeric) return -1;
              return a.partnerFirmName.localeCompare(b.partnerFirmName);
            })
          );
          setCatogryStatus("Query");
        }
        break;

      case "Resolved":
        {
          const res3 = props.partnerdataforResolved({
            accessToken: accessToken, });
          const ResolvedData = await res3;
          dataSource(
            ResolvedData?.slice()?.sort((a, b) => {
              const isANumeric = /^\d/.test(a.partnerFirmName);
              const isBNumeric = /^\d/.test(b.partnerFirmName);

              if (isANumeric && !isBNumeric) return 1;
              if (!isANumeric && isBNumeric) return -1;
              return a.partnerFirmName.localeCompare(b.partnerFirmName);
            })
          );
          setCatogryStatus("Resolved");
        }
        break;
      case "Rejected":
        {
          const res4 = props.partnerdataforRejected({
            accessToken: accessToken, });
          const RejectedData = await res4;
          dataSource(
            RejectedData?.slice()?.sort((a, b) => {
              const isANumeric = /^\d/.test(a.partnerFirmName);
              const isBNumeric = /^\d/.test(b.partnerFirmName);

              if (isANumeric && !isBNumeric) return 1;
              if (!isANumeric && isBNumeric) return -1;
              return a.partnerFirmName.localeCompare(b.partnerFirmName);
            })
          );
          setCatogryStatus("Rejected");
        }
        break;

      default:
        setFullDataSource([]);
        setDataSource2([]);
        break;
    }
    setSearchTextTable(""); // Clear search input on category change
  };

  const menu = (
    <Menu
      onClick={handleMenuClick}
      style={{ maxHeight: 500, overflow: "auto" }}
    >
      <Menu.Item key="search" disabled>
        <Input
          placeholder="Search partners..."
          prefix={<SearchOutlined />}
          value={searchText}
         onChange={(e) => {
                      const value = e.target.value;
                      setSearchText(value);
                      
                    }}
          onClick={(e) => e.stopPropagation()}
        />
      </Menu.Item>
      {filteredPartners.map((partner) => (
        <Menu.Item key={`${partner.partnerFirmId}`}>
          {partner.partnerFirmName} (
          {partner.partnerDisplayCode ? partner.partnerDisplayCode : "Null"})
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div style={{ maxWidth: "100%" }}>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            {/* <Button
              type="default"
              style={{ margin: "16px 0" , border: 'none', }}
              onClick={() => navigate(-1)}
            >
              &#8592;
            </Button> */}
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}
                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>
              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>
                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>
                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Col md={6} style={{ display: "flex" }} className="btn-partner">
            <div>
              {makerAction &&(<Dropdown
                overlay={menu}
                trigger={["click"]}
                open={visible}
                onOpenChange={(flag) => setVisible(flag)}
              >
                <Button
                  className="ant-btn ant-btn-default reset-btn"
                  type="primary"
                  style={{ width: 200 }}
                >
                  Add Partner Pricing
                </Button>
              </Dropdown>
              )}
            </div>
            <div>
              {/* <Button
                className="ant-btn ant-btn-default reset-btn"
                type="primary"
                style={{ marginLeft: 5, width: 200 }}
              >
                Add Partner Recovery
              </Button> */}
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ marginTop: 30, display: "flex" }}>
          <Col md={9}>
            <Radio.Group
              block
              options={options}
              defaultValue="Approved"
              onChange={(e) => {
                handleRadioChange(e.target.value);
              }}
              optionType="button"
              buttonStyle="solid"
              buttonCheckedBg="#1b8593"
            />
          </Col>
          <Col
            md={3}
            style={{
              display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              suffix={
                searchTextTable && (
                  <CloseOutlined
                    onClick={clearSearch}
                    style={{ cursor: "pointer" }}
                  />
                )
              }
              value={searchTextTable}
              onChange={handleSearch}
              style={{ width: 200 }}
            />
          </Col>
        </div>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Table dataSource={dataSource2} columns={columns} bordered={1} pagination={{pageSize:15}} />
        </Col>
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    partnerData: (data) => dispatch(partnerDataSuccess(data)),
    categorySetup: (data) => dispatch(getCategoryList(data)),
    partnerdataforApproved: (data) => dispatch(partnerDetailForApproved(data)),
    partnerdataforRejected: (data) => dispatch(partnerDetailForRejected(data)),
    partnerdataforPendingApproval: (data) => dispatch(partnerDetailForPendingApproval(data)),
    partnerdataforResolved: (data) => dispatch(partnerDetailForResolved(data)),
    partnerdataforQuery: (data) => dispatch(partnerDetailForQuery(data))
  };
};

const mapStateToProps = (state) => {
  return {
    partnersdata1: state.pricigPartner.state.partnerDetail,
    loading: state.pricigPartner.loading,
    error: state.pricigPartner.error,
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingManagement);